import FluxReferenceTransferAccessGate from './components/FluxReferenceTransferAccessGate';
import FluxReferenceTransferPage from './pages/FluxReferenceTransferPage';

export default function FluxReferenceTransferApp() {
  return (
    <FluxReferenceTransferAccessGate>
      <FluxReferenceTransferPage />
    </FluxReferenceTransferAccessGate>
  );
}
